import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import { getBarberUserId, getShop } from '../../auth/selectors';
import { createPaymentCard } from '../../main/payment/actions';

const withCreatePaymentCard = compose(
  connect(
    state => ({
      shopId: getShop(state),
      barberId: getBarberUserId(state),
    }),
    { createPaymentCard },
  ),
  withHandlers({
    createPaymentCard: props => (customerId, token) => {
      return props.createPaymentCard(customerId, token, { shopId: props.shopId, barberId: props.barberId });
    },
  })
);

export default withCreatePaymentCard;
